export default "__VITE_ASSET__yN5WWeo2__"